module.exports = __webpack_public_path__ + "static/media/3DPPA13.6e6d690f.jpg";